<section class="auth-shell">

  <div class="auth-brand">
    <span class="word">Clug</span>
  </div>

  <!-- SUCCESS STATE -->
  <div class="auth-card" *ngIf="successfullySet">
    <div class="state-card-success">
      <div class="ico"><i class="bi bi-check-circle-fill"></i></div>
      <h3>Password set</h3>
      <p>You can now sign in with your new password.</p>
      <button type="button" class="btn btn-primary btn-block" (click)="goToLogin()">
        Go to sign in
      </button>
    </div>
  </div>

  <!-- EXPIRED STATE -->
  <div class="auth-card" *ngIf="!successfullySet && linkExpired">
    <div class="state-card-error">
      <div class="ico"><i class="bi bi-shield-exclamation"></i></div>
      <h3>Link expired</h3>
      <p>This reset link is no longer valid. Request a new one and we'll email it to you.</p>
      <button type="button" class="btn btn-primary btn-block" (click)="requestNewLink()">
        Request a new link
      </button>
    </div>
  </div>

  <!-- FORM STATE -->
  <div class="auth-card" *ngIf="!successfullySet && !linkExpired">
    <h1>Set your password</h1>
    <p class="auth-sub">Choose a strong password to secure your account.</p>

    <div class="alert-box alert-error" *ngIf="err" role="alert" aria-live="polite">
      <i class="bi bi-exclamation-circle-fill"></i>
      <span class="alert-msg">{{ err }}</span>
      <button type="button" class="alert-close" (click)="err=''" aria-label="Dismiss">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <form [formGroup]="setPasswordForm" (ngSubmit)="setPassword()" novalidate>

      <div class="field">
        <label for="email">Email</label>
        <div class="input-form-wrap with-left">
          <span class="input-affix left"><i class="bi bi-envelope"></i></span>
          <input type="email" id="email" class="input-form" formControlName="email" autocomplete="email"
            placeholder="you@company.com" />
        </div>
        <div class="field-error" *ngIf="submitted && rForm['email'].errors">
          <i class="bi bi-exclamation-circle"></i>
          <span *ngIf="rForm['email'].errors['required']">Email is required.</span>
        </div>
      </div>

      <div class="field">
        <label for="password">New password <span class="req">*</span></label>
        <div class="input-form-wrap">
          <input [type]="showPassword ? 'text' : 'password'" id="password" class="input-form" formControlName="password"
            (keyup)="validatePasswordConfirmation()" autocomplete="new-password"
            [class.is-invalid]="submitted && rForm['password'].errors" />
          <button type="button" class="input-affix" (click)="showPassword = !showPassword"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
            <i class="bi" [class.bi-eye]="showPassword" [class.bi-eye-slash]="!showPassword"></i>
          </button>
        </div>
        <div class="pw-rules" aria-label="Password requirements">
          <div class="pw-rule" [class.met]="rule8">
            <i class="bi" [class.bi-check-circle-fill]="rule8" [class.bi-circle]="!rule8"></i>
            8+ characters
          </div>
          <div class="pw-rule" [class.met]="ruleUpper">
            <i class="bi" [class.bi-check-circle-fill]="ruleUpper" [class.bi-circle]="!ruleUpper"></i>
            1 uppercase
          </div>
          <div class="pw-rule" [class.met]="ruleNumber">
            <i class="bi" [class.bi-check-circle-fill]="ruleNumber" [class.bi-circle]="!ruleNumber"></i>
            1 number
          </div>
          <div class="pw-rule" [class.met]="ruleSymbol">
            <i class="bi" [class.bi-check-circle-fill]="ruleSymbol" [class.bi-circle]="!ruleSymbol"></i>
            1 symbol
          </div>
        </div>
        <div class="field-error" *ngIf="submitted && rForm['password'].errors">
          <i class="bi bi-exclamation-circle"></i>
          <span *ngIf="rForm['password'].errors['required']">Password is required.</span>
          <span *ngIf="rForm['password'].errors['minlength']">Password must be at least 8 characters.</span>
        </div>
      </div>

      <div class="field">
        <label for="password_confirmation">Confirm password <span class="req">*</span></label>
        <div class="input-form-wrap">
          <input [type]="showConfirm ? 'text' : 'password'" id="password_confirmation" class="input-form"
            formControlName="password_confirmation" (keyup)="validatePasswordConfirmation()" autocomplete="new-password"
            [class.is-invalid]="submitted && rForm['password_confirmation'].errors" />
          <button type="button" class="input-affix" (click)="showConfirm = !showConfirm"
            [attr.aria-label]="showConfirm ? 'Hide password' : 'Show password'">
            <i class="bi" [class.bi-eye]="showConfirm" [class.bi-eye-slash]="!showConfirm"></i>
          </button>
        </div>
        <div class="field-error" *ngIf="submitted && rForm['password_confirmation'].errors">
          <i class="bi bi-exclamation-circle"></i>
          <span *ngIf="rForm['password_confirmation'].errors['required']">Confirmation is required.</span>
          <span *ngIf="rForm['password_confirmation'].errors['minlength']">Password must be at least 8
            characters.</span>
          <span *ngIf="rForm['password_confirmation'].errors['confirmPassword']">Passwords don't match.</span>
        </div>
      </div>

      <button class="btn btn-primary btn-block" type="submit" [disabled]="loading" style="margin-top: 8px;">
        <span class="auth-spinner" *ngIf="loading" aria-hidden="true"></span>
        <span *ngIf="!loading">Set password</span>
        <span *ngIf="loading">Setting…</span>
      </button>
    </form>
  </div>

  <!-- <div class="auth-foot" *ngIf="!successfullySet && !linkExpired">
    Need access? <a href="mailto:admin@clug.app">Contact your workspace admin.</a>
  </div> -->
</section>